import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { useParams } from '@thd-olt-component-react/router';
import { Pagination } from '@thd-olt-component-react/pagination';
import { useStore } from '../../../../store';
import { Spinner } from '../../../../components/common/Spinner/Spinner';
import { pageLoadEvents } from '../../../../utils/analytics/index';
import { neighborCalc } from '../../../../utils/paginationUtils';
import MobileJobApplicants from './MobileJobApplicants';
import JobApplicantsDesktop from './JobApplicantsDesktop';

const _JobApplicants = ({ goToRecommended }) => {

  const {
    jobApplicantStore: {
      setJobPostingMetaData,
      jobApplicants,
      isJobApplicantsLoading,
      jobApplicantsPaginationInfo,
      fetchJobApplicants,
      page = 1,
      setPage,
      sort,
      resetSort,
      filter,
      setFilter,
      resetFilter
    }
  } = useStore();

  const sectionRef = useRef(null);

  const { jobPostingId } = useParams();

  useEffect(() => {
    pageLoadEvents.jobApplicantsPage();
    setJobPostingMetaData({ jobPostingId });
  }, []);

  useEffect(() => {
    // if there are no applicants for the job posting on initial call, update filter to show all
    if (jobApplicants?.length === 0 && filter === undefined) {
      setFilter('showAll');
    }
  }, [jobApplicants]);

  useEffect(() => {
    fetchJobApplicants();
  }, [page, sort, filter]);

  useEffect(() => {
    // reset sort on cleanUp
    return () => {
      resetSort();
      resetFilter();
    };
  }, []);

  const handlePageChange = (p) => {
    sectionRef.current.scrollIntoView();
    setPage(p);
  };

  if (isJobApplicantsLoading) {
    return <Spinner />;
  }

  return (
    <main>
      <section className="my-dashboard__tab-content my-dashboard__candidate-table" ref={sectionRef}>
        <div className="ptp-hidden__sm-up">
          <MobileJobApplicants goToRecommended={goToRecommended} />
        </div>
        <div className="ptp-hidden__xs-down">
          <JobApplicantsDesktop goToRecommended={goToRecommended} />
        </div>
        {jobApplicantsPaginationInfo.totalPages !== 1 && (
          <div className="slm__pagination_container" data-testid="job-applicants-pagination">
            <Pagination
              showArrows
              pagesBeforeDotsShow={3}
              totalPages={jobApplicantsPaginationInfo.totalPages}
              currentPage={page}
              onPageChanged={handlePageChange}
              rightNeighbors={neighborCalc(jobApplicantsPaginationInfo.totalPages, page)}
            />
          </div>
        )}
      </section>
    </main>
  );
};

const JobApplicants = observer(_JobApplicants);
export default JobApplicants;
